import React from 'react';
import TopNavigation from '@cloudscape-design/components/top-navigation';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BaseAppLayout = (props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  // Flip the whole document direction (nav + page content) with the language,
  // not just this component's own markup.
  React.useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'ar' ? 'en' : 'ar');
  };

  return (
    <TopNavigation
      identity={{
        href: "/",
        title: "ILAF Reports Portal",
      }}
      utilities={[
        {
          type: "button",
          text: t("Switch Lanuage"),
          onClick: toggleLanguage,
        },
        {
          type: "menu-dropdown",
          text: "QR",
          title: "QR",
          items: [
            {
              id: "qr_upload",
              text: "QR Scan Upload",
              href: "/qr_upload",
            },
          ],
          onItemClick: ({ detail }) => {
            if (detail.id === "qr_upload") navigate("/qr_upload");
          },
        },
      ]}
      {...props}
    />
  );
};

export default BaseAppLayout;
